module.exports = __webpack_public_path__ + "static/media/popins_empty_state.fa2bd617.svg";